// src/components/FamilyUsageAnalysis.tsx
import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import submitn from "../Common/Images/submit_n.gif"
import submito from "../Common/Images/submit_o.gif"
import Loading from "../Common/Loading"

interface FamilyUsageData {
  SchoolCode: string;
  FamilyName: string;
  FamilyLogin: string;
  RegisteredDate: string;
  RegChildren: number;
  TotalUsage: string;
  EMail: string;
}

interface PaginationInfo {
  total: number;
  startRecNo: number;
  rowsPerPage: number;
  showNulls: boolean;
}

interface ApiResponse {
  success: boolean;
  data: FamilyUsageData[];
  pagination?: PaginationInfo;
  error?: string;
}

const API_BASE = process.env.REACT_APP_DOCUMENT_LINK;

document.body.style.backgroundColor="azure"
const EL_Dealer_UsageAnalysis: React.FC = () => {
  // State for filters
  const [familyName, setFamilyName] = useState('');
  const [period, setPeriod] = useState<'A' | 'P'>('A');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  // State for data and pagination
  const [data, setData] = useState<FamilyUsageData[]>([]);
  const [pagination, setPagination] = useState<PaginationInfo>({
    total: 0,
    startRecNo: 1,
    rowsPerPage: 20,
    showNulls: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Load data
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      if (familyName) params.append('family', familyName);
      params.append('period', period);
      if (period === 'P') {
        params.append('fromDate', fromDate);
        params.append('toDate', toDate);
      }
      params.append('startRecNo', pagination.startRecNo.toString());
      params.append('rowsPerPage', pagination.rowsPerPage.toString());
      params.append('showNulls', pagination.showNulls.toString());

      const response = await fetch(`${API_BASE}/api/family-usage/data/?${params.toString()}`);
      if (!response.ok) throw new Error('Failed to fetch data');
      const result: ApiResponse = await response.json();

      if (result.success) {
        setData(result.data || []);
        if (result.pagination) {
          setPagination(result.pagination);
        }
      } else {
        throw new Error(result.error || 'Unknown error');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    
document.body.style.backgroundColor="azure"

  }, []);

  // Load when filters or pagination change
  useEffect(() => {
    fetchData();
  }, [familyName, period, fromDate, toDate, pagination.startRecNo, pagination.rowsPerPage]);

  // Handle period selection
  const handlePeriodChange = (newPeriod: 'A' | 'P') => {
    setPeriod(newPeriod);
    if (newPeriod === 'A') {
      setFromDate('');
      setToDate('');
    } else {
      // Default to last month
      const lastMonth = new Date();
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      setFromDate(format(lastMonth, 'yyyy-MM-dd'));
      setToDate(format(new Date(), 'yyyy-MM-dd'));
    }
    // Reset to first page when filters change
    setPagination(prev => ({ ...prev, startRecNo: 1 }));
  };

  // Handle form submission
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setPagination(prev => ({ ...prev, startRecNo: 1 })); // Reset to first page
    fetchData();
  };

  // Handle pagination
  const handlePageChange = (newPage: number) => {
    setPagination(prev => ({
      ...prev,
      startRecNo: newPage
    }));
  };

  // Calculate total pages
  const totalPages = Math.ceil(pagination.total / pagination.rowsPerPage);

  return (
    <div id="divMain" style={{ fontFamily: 'Arial', fontSize: '10pt' }}>
      <h2 style={{color:"navy", textAlign:"center", margin:"5px"}}>Kinetic Education</h2>
      <div style={{display:"flex", justifyContent:"flex-end", gap:"2%", marginBottom:"5px", marginRight:"5px", marginTop:"0px"}}>
        <a href="/SUPPORT/DealerDashboard" style={{textDecoration:'underline', color:'blue', fontWeight:'bolder'}}>Back To Menu</a>
        <a href="/SUPPORT/SupportLoggedOut" style={{textDecoration:'underline', color:'blue', fontWeight:'bolder'}}>Logout</a>
      </div>
      {/* Header Table */}
      <table align="center" id="tblFilter" cellPadding="3" cellSpacing="0" style={{ width: '100%', border: 'solid 1px blue' }}>
        <tbody>
          <tr style={{ paddingBottom: '5px', paddingTop: '1px' }}>
            <td colSpan={2} align="center" style={{
              fontSize: '14pt',
              fontWeight: 'bold',
              color: 'blue',
              backgroundColor: 'azure',
              borderBottom: 'solid 1px blue'
            }}>
              Family Usage Analysis
            </td>
          </tr>
          <tr style={{ paddingBottom: '5px', paddingTop: '1px' }}>
            <td align="left">
              Usage for&nbsp;&nbsp;&nbsp;&nbsp;
              Family &nbsp;
              <input
                type="text"
                id="txtFamily"
                value={familyName}
                onChange={(e) => {
                  setFamilyName(e.target.value);
                  setPagination(prev => ({ ...prev, startRecNo: 1 }));
                }}
                style={{ borderStyle: 'solid', borderWidth: '1px', borderColor: '#a0a0ff' }}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <input
                type="radio"
                id="rdoA"
                name="rdoPD"
                value="A"
                checked={period === 'A'}
                onChange={() => handlePeriodChange('A')}
              /> ALL dates&nbsp;&nbsp;&nbsp;&nbsp;
              <input
                type="radio"
                id="rdoP"
                name="rdoPD"
                value="P"
                checked={period === 'P'}
                onChange={() => handlePeriodChange('P')}
              /> Specify period&nbsp;&nbsp;
              <span id="tdPeriod" style={{ visibility: period === 'P' ? 'visible' : 'hidden' }}>
                <input
                  type="date"
                  id="calFromDt"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    setPagination(prev => ({ ...prev, startRecNo: 1 }));
                  }}
                  style={{ border: '1px solid #a0a0ff', padding: '2px' }}
                />
                &nbsp;To&nbsp;
                <input
                  type="date"
                  id="calToDt"
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                    setPagination(prev => ({ ...prev, startRecNo: 1 }));
                  }}
                  style={{ border: '1px solid #a0a0ff', padding: '2px' }}
                />
              </span>
            </td>
            <td align="right">
              <button
                type="button"
                onClick={handleSubmit}
                style={{
                  backgroundImage: `url(${submitn})`,
                  backgroundSize: 'cover',
                  width: '80px',
                  height: '30px',
                  border: 'none',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => (e.currentTarget.style.backgroundImage = `url(${submito})`)}
                onMouseOut={(e) => (e.currentTarget.style.backgroundImage = `url(${submitn})`)}
              />
            </td>
          </tr>
        </tbody>
      </table>

      {/* Data Table */}
      <table align="center" id="Table1" cellPadding="2" cellSpacing="0" style={{ width: '100%' }}>
        <tbody>
          <tr>
            <td align="left">
              <div style={{ height: '80%', overflowY: 'auto', border: '1px solid #a0a0ff' }}>
                {error && <div style={{ color: 'red', padding: '10px' }}>{error}</div>}
                {loading ? (
                 <Loading />
                ) : (
                  <>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#c7ddfd', color:"#2859ac"}}>
                          <th style={{ padding: '8px', border: '1px solid #a3c0e8', textAlign: 'left',fontWeight:"normal"  }}>School Code</th>
                          <th style={{ padding: '8px', border: '1px solid #a3c0e8', textAlign: 'left',fontWeight:"normal"}}>Family Name</th>
                          <th style={{ padding: '8px', border: '1px solid #a3c0e8', textAlign: 'left',fontWeight:"normal"}}>Family Login</th>
                          <th style={{ padding: '8px', border: '1px solid #a3c0e8', textAlign: 'center',fontWeight:"normal"}}>Registered On</th>
                          <th style={{ padding: '8px', border: '1px solid #a3c0e8', textAlign: 'center',fontWeight:"normal"}}>Reg. Children</th>
                          <th style={{ padding: '8px', border: '1px solid #a3c0e8', textAlign: 'center',fontWeight:"normal"}}>Total Usage</th>
                          <th style={{ padding: '8px', border: '1px solid #a3c0e8', textAlign: 'left',fontWeight:"normal"}}>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 ? (
                          data.map((row, index) => (
                            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f4faff' : '#ffffff' }}>
                              <td style={{ padding: '8px', borderRight: '1px solid #a3c0e8', textAlign: 'left' }}>{row.SchoolCode}</td>
                              <td style={{ padding: '8px', borderRight: '1px solid #a3c0e8', textAlign: 'left' }}>{row.FamilyName}</td>
                              <td style={{ padding: '8px', borderRight: '1px solid #a3c0e8', textAlign: 'left' }}>{row.FamilyLogin}</td>
                              <td style={{ padding: '8px', borderRight: '1px solid #a3c0e8', textAlign: 'center' }}>{row.RegisteredDate}</td>
                              <td style={{ padding: '8px', borderRight: '1px solid #a3c0e8', textAlign: 'center' }}>{row.RegChildren}</td>
                              <td style={{ padding: '8px', borderRight: '1px solid #a3c0e8', textAlign: 'center' }}>{row.TotalUsage}</td>
                              <td style={{ padding: '8px', borderRight: '1px solid #a3c0e8', textAlign: 'left' }}>{row.EMail}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={7} style={{ padding: '20px', textAlign: 'center' }}>No data found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalPages > 1 && (
                      <div style={{ padding: '10px', textAlign: 'center', backgroundColor:"#c7ddfd", marginTop:"20px", border:"solid 2px #80A0FF", color:"#2859ac", fontWeight:"bold"}}>
                        <button
                          onClick={() => handlePageChange(Math.max(1, pagination.startRecNo - pagination.rowsPerPage))}
                          disabled={pagination.startRecNo <= 1}
                          style={{ marginRight: '10px' }}
                        >
                          Previous
                        </button>
                        <span>
                          Page {Math.ceil(pagination.startRecNo / pagination.rowsPerPage)} of {totalPages}
                        </span>
                        <button
                          onClick={() => handlePageChange(Math.min(pagination.startRecNo + pagination.rowsPerPage, pagination.total))}
                          disabled={pagination.startRecNo + pagination.rowsPerPage > pagination.total}
                          style={{ marginLeft: '10px' }}
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Hidden fields */}
      <input type="hidden" id="hidPeriod" value={period} />
      <input type="hidden" id="hidStartRecNo" value={pagination.startRecNo} />
      <input type="hidden" id="hidRowsPerPage" value={pagination.rowsPerPage} />
      <input type="hidden" id="hidShowNulls" value={pagination.showNulls.toString()} />
    </div>
  );
};

export default EL_Dealer_UsageAnalysis;